import React from 'react';
import uniq from 'lodash.uniq';
import { useTypedSelector } from 'js/selectors/typedUseSelector';
import { DEFAULT_HAND_CURSOR_ID } from 'js/config/consts';

import HandMenu from '../AnimationPanels/HandMenu';
import { useAnimationStageContext } from '../AnimationPanels/AnimationStageContext';

const DrawHandMenu = () => {
  const { currentSelectedCursor, onCursorChoice } = useAnimationStageContext();

  const hands = useTypedSelector(state => state.cursors.handDraw);
  const filters = ['all', ...uniq(hands.map(hand => hand.group.toLowerCase()).sort())];

  return (
    <HandMenu
      hands={hands}
      onSelection={onCursorChoice}
      selectedCursorId={currentSelectedCursor}
      defaultCursorId={DEFAULT_HAND_CURSOR_ID}
      defaultCursorGroup="rosie"
      filters={filters}
    />
  );
};

export default DrawHandMenu;
